import { browser } from '$app/environment';
import { useAccount, type Account } from '$lib/account/account';
import { useLocalSession } from '$lib/local-sesson/local-sesson';
import { get, writable } from 'svelte/store';
import { defaultBookingData } from './default-booking-data';

//
export interface BookingData {
	// step 1: location
	class_type_id: number;
	location_id: number | null;
	semester_id: number | null;
	// step 2: choose club / offer
	club_id: number | null;
	offer_id: number | null;
	experience_level_ids: number[] | null;
	lesson_type_ids: number[] | null;
	age_ids: number[] | null;
	tz: string;
	// step 2a: parent info
	nameFirst: string | null;
	nameLast: string | null;
	email: string | null;
	phone: string | null;
	gender: string | null;
	sourceId: number | null;
	address: {
		id: number | null;
		address1: string | null;
		address2: string | null;
		city: string | null;
		state: string | null;
		zip: string | null;
		country: string | null;
		latitude: number | null;
		longitude: number | null;
		isDefault: boolean | null;
	};
	// step 3: choose students
	student_ids: number[] | null;
	// step 3a: perfer time (offering)
	prefered_start_date: string | null;
	prefered_times: { dow: string; time_from: string; time_to: string }[];
	prefered_tz: string;
	// step 4: billing
	stripe_customer_id: string | null;
	stripe_payment_method_id: string | null;
	// store checkout result. If any step / request failed after checkout then repeat process can skip checkout
	checkout_result: Record<string, any> | null;
	// step 5: confirm
	totalPrice: number | null;
	notes: string | null;
	// registraion result
	registration_result: Record<string, any> | null;
	// preference saving result
	prefered_result: Record<string, any> | null;
	// featureOnCalendar
	featureOnCalendar: boolean | null;
	utmOptions: {
		utm_source: string | null;
		utm_medium: string | null;
		utm_campaign: string | null;
		utm_term: string | null;
		utm_content: string | null;
	};
	// reference code
	code: string | null;
	bundleId: number | null;
	dropIn: boolean | null;
}

const bookingData = writable<BookingData>({ ...defaultBookingData });

const bookingDataLoaded = writable(false);

export const useBookingData = () => {
	return {
		bookingData,
		bookingDataLoaded
	};
};

// fetch from local session
if (browser) {
	const ls = useLocalSession<BookingData>('chessat3-booking-data');

	const d = ls.invoke();
	if (d) bookingData.set(d);
	bookingDataLoaded.set(true);

	// sync data from store to session
	bookingData.subscribe((d) => {
		if (!d) ls.del();
		else ls.reset(d);
	});
}

const lastStatus = writable<undefined | null | Account>();

// when account signout, clear session
useAccount().account.subscribe((account) => {
	// when sign out
	if (account === null && get(lastStatus) != void 0) {
		const cur = get(bookingData);

		bookingData.set({ ...defaultBookingData, club_id: cur.club_id, offer_id: cur.offer_id });
	}

	lastStatus.set(account);
});
